import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageChanger from "../../Helpers/Components/Pagination"
import Handler from "../../Helpers/Components/Handler"
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder"
import DatePicker from "react-multi-date-picker";
import { DropdownToggle, DropdownButton } from '../../Helpers/Components/Dropdown';
import { toast } from "react-toastify";
import { getCookie, reloadWindow } from "../../Helpers/Utils";
import * as FileSaver from "file-saver";
import XLSX from 'sheetjs-style';
import Modal from '../../Helpers/Components/Modal'
import Select from 'react-select'

const List = () => {
    const { pageNo } = useParams()
    const person = getCookie('person')
    const navigate = useNavigate()
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [custDetails, setCustDetails] = useState([])
    const [modal, setModal] = useState(false)
    const [filterModal, setFilterModal] = useState(false);
    const filterToggle = () => setFilterModal(!filterModal)
    const toggle = () => setModal(!modal)
    const [modal1, setModal1] = useState(false)
    const [filterData, setFilterData] = useState([])
    const toggle1 = () => setModal1(!modal1)
    // Delivery / Pickup sales report download (Admin/salesReport API)
    const [salesModal, setSalesModal] = useState(false)
    const [salesData, setSalesData] = useState({ from: "", to: "", person: "all" })
    const [salesLoading, setSalesLoading] = useState(false)
    const salesToggle = () => setSalesModal(!salesModal)
    const [lead, setLead] = useState()
    const [password, setPassword] = useState({ password: "", confirmpassword: "", id: "", name: "" })
    const [status, setStatus] = useState({ id: "", status: true })
    const [filter, setFilter] = useState({ count: 10, sortBy: "id", sort: false, search: "", status: "All" })
    const [filterDate, setFilterDate] = useState({ from: "", to: "" })
    const [checkDate, setCheckDate] = useState()
    const calendarRef = useRef();
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsgeet.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [search, setSearch] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");
    const sort = (sortBy, sort) => setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
    const setPageNo = (value) => navigate(`/subadmin/${value}`)
    const handleKeyDown = (event) => { if (event.key === "Enter") { event.preventDefault(); handleSearch(); } };
    const getLead = async () => {
        const response = await Handler({ method: "get", url: '/admin/lead' })
        if (response?.success) {
            setLead(response?.data?.filter(item => item.status))
        } else {
            setLead([])
        }
    }
    const openModal = (id) => {
        setPassword((prevValue) => ({ ...prevValue, id: id, password: "", confirmpassword: "" }));
        toggle();
    }
    const modalOpen = (id, value) => {
        setStatus({ status: value === "Add" ? true : false, id: id })
        toggle1()
    }
    const handleSubmit = async () => {
        if (!password?.password) {
            toast.error("Password is required")
        } else if (password?.password !== password?.confirmpassword) {
            toast.error("Password doesn't match")
        } else {
            setLoading(true)
            const response = await Handler({ method: "patch", data: { password: password?.password }, url: `/admin/changepassword/${password?.id}` })
            if (response?.success) {
                toggle();
                toast.success(response?.message);
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const getSubadminDetails = async () => {
        setLoading(true);
        const response = await Handler({
            method: "post",
            url: `/admin/subadmin/${pageNo - 1}?count=${filter?.count || 10}`,
            data: {
                ...(appliedSearch ? { searchValue: appliedSearch } : {}),
                ...(filter?.status !== "All" ? { status: filter?.status } : {}),
                ...(checkDate?.length ? { from: moment(new Date(checkDate[0])).format("DD-MM-YYYY"), to: checkDate?.length >= 2 ? moment(new Date(checkDate[1])).format("DD-MM-YYYY") : moment(new Date(checkDate[0])).format("DD-MM-YYYY") } : {}),
                sort: filter?.sort,
                sortBy: filter?.sortBy
            }
        });
        if (response?.success) {
            setCustDetails(response?.data?.result);
            setNext(response?.data?.next);
        } else {
            setCustDetails([]);
            setNext(false);
        }
        setLoading(false);
    };
    const handleStatus = async (id, status) => {
        setLoading(true)
        const response = await Handler({ method: "patch", data: {}, url: `/admin/subadmin/status/${id}?status=${status}` })
        if (response?.success) {
            toast.success(response?.message)
            getSubadminDetails()
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    const handleLead = async () => {
        setLoading(true);
        const response = await Handler({ url: `admin/lead/status/${status?.id}?status=${status?.status}`, data: {}, method: "patch" })
        if (response?.success) {
            toggle1();
            setStatus({ id: "", status: true })
            toast.success("Updated Successfully");
            setTimeout(() => {
                reloadWindow()
            }, 1500);
        } else {
            setLoading(false);
            toast.error(response?.message)
        }
    }
    const getFilteredDetails = async () => {
        const from = filterDate?.from ? moment(new Date(filterDate?.from))?.format("DD-MM-YYYY") : ""
        const to = filterDate?.to ? moment(new Date(filterDate?.to))?.format("DD-MM-YYYY") : (filterDate?.from ? moment(new Date(filterDate?.from))?.format("DD-MM-YYYY") : "")
        const response = await Handler({ method: 'post', url: `/admin/subadmin/year/report`, data: { ...(from ? { from } : {}), ...(to ? { to } : {}) } })
        if (response?.success) {
            setFilterData(response?.data)
        } else {
            setFilterData([])
        }
    }
    const exportToExcel = async () => {
        filterToggle()
        const ws = XLSX?.utils?.json_to_sheet(filterData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "SalesReport" + fileExtension);
    }
    const formatSalesDate = (date) => date ? moment(date).format("DD/MM/YYYY hh:mm A") : ""
    const exportSalesReport = async () => {
        if (!salesData?.from) return toast.error("From date is required")
        if (!salesData?.to) return toast.error("To date is required")
        if (new Date(salesData?.to) < new Date(salesData?.from)) return toast.error("From date must be before To date")
        setSalesLoading(true)
        const response = await Handler({
            method: "post", url: `/admin/sales/report`, data: {
                from: new Date(salesData?.from),
                to: new Date(salesData?.to),
                ...(salesData?.person && salesData?.person !== "all" ? { person: salesData?.person } : {})
            }
        })
        setSalesLoading(false)
        if (!response?.success) {
            return toast.error(response?.message)
        }
        const { deliveries = [], pickups = [] } = response?.data || {}
        const toRow = (element) => ({
            "Booking Id": element?.bookingId,
            "Start Date": formatSalesDate(element?.startDate),
            "End Date": formatSalesDate(element?.endDate),
            "Type": element?.type,
            "Done By": element?.by,
            "At": formatSalesDate(element?.at),
        })
        const wb = { Sheets: {}, SheetNames: [] };
        const deliverySheet = XLSX?.utils?.json_to_sheet(deliveries?.length ? deliveries?.map(toRow) : [{}]);
        wb.Sheets['Deliveries'] = deliverySheet;
        wb.SheetNames.push('Deliveries');
        const pickupSheet = XLSX?.utils?.json_to_sheet(pickups?.length ? pickups?.map(toRow) : [{}]);
        wb.Sheets['Pickups'] = pickupSheet;
        wb.SheetNames.push('Pickups');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Sales Report" + fileExtension);
        setSalesModal(false)
        setSalesData({ from: "", to: "", person: "all" })
    }
    const handleSearch = () => {
        setPageNo(1);
        setAppliedSearch(search);
    };
    useEffect(() => {
        if (filterModal) {
            getFilteredDetails()
        } else {
            setFilterDate({ from: "", to: "" })
        }
    }, [filterModal])
    useEffect(() => {
        if (filterDate?.from && filterModal) {
            getFilteredDetails()
        }
    }, [filterDate])
    useEffect(() => {
        getSubadminDetails()
    }, [pageNo, filter, checkDate, appliedSearch])
    useEffect(() => {
        getLead()
    }, [])

    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Subadmin List</h5>
            <div className="layout-card mt-4">
                <div className="row justify-content-between align-items-center">
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center gap-2">
                            <div className="input-group">
                                <input type="text" className="form-control search-input" onKeyDown={handleKeyDown} autoComplete="off" placeholder="Search..." value={search} onChange={(e) => { if (e.target.value) setSearch(e.target.value); else { setSearch(""); setAppliedSearch(""); setPageNo(1); } }} name="search" />
                                <span className="input-group-text cancel-icon">{search && (<i className="fa-solid fa-circle-xmark cursor-pointer text-theme" onClick={() => { setSearch(""); setAppliedSearch(""); setPageNo(1); }} />)}</span>
                            </div>
                            <button className="btn btn-sm btn-theme" onClick={handleSearch}>Search</button>
                        </div>
                    </div>
                    <div className="col-lg-4 d-flex align-items-center justify-content-end">
                        {/* <button className="btn-theme btn me-2" onClick={}>Download</button> */}
                        {person === "admin" ? (loading ? <i className="fa-solid fa-spinner fa-spin me-2"></i> : <i className="fa-solid fa-download me-2 fs-5 mb-0 cursor-pointer" onClick={salesToggle}></i>) : ""}
                        <button className="btn-theme btn me-2" onClick={filterToggle}>Report</button>
                        <button className="btn-theme btn" onClick={() => navigate(`/subadmin/register`)}>Register</button>
                    </div>
                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th><div className='sort-head'><div className='sort-arrow'><i className={filter?.sortBy === "id" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("id", false)} >▲</i><i className={filter?.sortBy === "id" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("id", true)} >▼</i></div> Subadmin Id</div></th>
                                <th><div className='sort-head'><div className='sort-arrow'><i className={filter?.sortBy === "name" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("name", false)} >▲</i><i className={filter?.sortBy === "name" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("name", true)} >▼</i></div> Name </div></th>
                                <th>Phone Number</th>
                                {/* <th><div className='sort-head'><div className='sort-arrow'><i className={filter?.sortBy === "createdAt" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("createdAt", false)} >▲</i><i className={filter?.sortBy === "createdAt" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("createdAt", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Created At</button> </div></th> */}
                                <th>
                                    <DropdownToggle label={
                                        <> Status <i className="fa-solid fa-caret-down"></i> </>}>
                                        <DropdownButton label="All" className={`${filter?.status === "All" ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, status: "All" })) }} />
                                        <DropdownButton label="Active" className={`${filter?.status === true ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, status: true })) }} />
                                        <DropdownButton label="Deactive" className={`${filter?.status === false ? "active-option" : ""}`} onClick={() => { setFilter((prev) => ({ ...prev, status: false })) }} />
                                    </DropdownToggle>
                                </th>
                                <th className="text-center">Lead Taken</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${!value?.status ? "text-red" : ""}`}>
                                            <td><a className="" href={`/subadmin/view/${value?.id}`}>{value?.id || "-"}</a></td>
                                            <td className="text-capitalize">{(value?.name || "-")}</td>
                                            <td>{value?.phone || "-"}</td>
                                            {/* <td>{value?.createdAt ? moment(value?.createdAt).format('DD/MM/YYYY') : ""}</td> */}
                                            <td><button className={`${value?.status ? "btn-danger" : "btn-success"} btn btn-sm`} onClick={() => handleStatus(value?.id, !value?.status)}>{!value?.status ? "Activate" : "Deactivate"}</button></td>
                                            <td className="text-center"><button className="lead-taken btn btn-sm btn-primary" type="button" onClick={() => { modalOpen(value?.id, (!!(lead && lead.find(({ leadId }) => leadId === value?.id))) ? "Delete" : "Add") }}>{(!!(lead && lead.find(({ leadId }) => leadId === value?.id))) ? "Delete" : "Add"}</button></td>
                                            <td className="text-center"><button className="btn btn-sm btn-secondary" onClick={() => openModal(value?.id)}>Change Password</button></td>
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={6}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={6} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setFilter((prev) => ({ ...prev, count: selectedoption.value }))
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='subadmin' />
            </div>
            <DatePicker
                ref={calendarRef}
                range
                className='rmdp-mobile'
                inputClass='d-none'
                onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); } }}
                value={checkDate}
                mobileButtons={[
                    {
                        label: "RESET",
                        type: "button",
                        className: "rmdp-button rmdp-action-button",
                        onClick: () => setCheckDate({}),
                    },
                ]}
            />
            <Modal header='Change Password' onShow={modal} toggle={toggle} overlayToggle={toggle}>
                <div className="my-3">
                    <label htmlFor="password" className="mb-1"> Password</label>
                    <input disabled={loading} autoComplete="off" id="password" name="password" className="form-control input-theme" placeholder="Password" value={password?.password || ""} onChange={(e) => { setPassword((prev) => ({ ...prev, password: e.target.value })) }} type="text" />
                </div>
                <div className="my-3">
                    <label htmlFor="confirmpassword" className="mb-1">Confirm Password</label>
                    <input disabled={loading} autoComplete="off" id="confirmpassword" name="confirmpassword" className="form-control input-theme" placeholder="Confirm Password" value={password?.confirmpassword || ""} onChange={(e) => { setPassword((prev) => ({ ...prev, confirmpassword: e.target.value })) }} type="text" />
                </div>
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-success btn-sm" disabled={loading} onClick={handleSubmit}>
                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}
                    </button>{' '}
                    <button className="btn btn-danger btn-sm" disabled={loading} onClick={toggle}>
                        {loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Cancel"}
                    </button>
                </div>
            </Modal>
            <Modal header='Status Update' onShow={modal1} toggle={toggle1} overlayToggle={toggle1}>
                Do you want to {`${status?.status ? "Add" : "Delete"} ${status?.id}`}?
                <div className="pt-4 pb-2 text-center">
                    <button className="btn btn-success btn-sm" onClick={() => handleLead()}>
                        Yes
                    </button>{' '}
                    <button className="btn btn-danger btn-sm" onClick={() => { toggle1(); setStatus({ id: "", status: true }) }}>
                        No
                    </button>
                </div>
            </Modal>
            <Modal fullScreen={true} header='Report' onShow={filterModal} toggle={filterToggle} overlayToggle={filterToggle}>
                <div className="row justify-content-between">
                    <div className="col-md-8 d-md-flex align-items-center mt-3 mt-md-0">
                        <div className="me-2 filter-date datepicker-top">
                            <DatePicker
                                autoComplete="off"
                                selected={filterDate?.from}
                                id="from"
                                showYearDropdown
                                showMonthDropdown
                                timeIntervals={15}
                                placeholder="From"
                                value={filterDate?.from || ""}
                                onChange={(date) => { setFilterDate((prevValues) => ({ ...prevValues, from: date })) }}
                                dateFormat="dd/MM/yyyy"
                                className="form-control form_input text-uppercase me-2"
                            />
                        </div>
                        <div className="me-2 filter-date datepicker-top">
                            <DatePicker
                                autoComplete="off"
                                selected={filterDate?.to}
                                id="from"
                                showYearDropdown
                                showMonthDropdown
                                placeholder="To"
                                timeIntervals={15}
                                onChange={(date) => { setFilterDate((prevValues) => ({ ...prevValues, to: date })) }}
                                dateFormat="dd/MM/yyyy"
                                value={filterDate?.to || ""}
                                minDate={filterDate?.from}
                                disabled={filterDate?.from === "" ? true : false}
                                className="form-control form_input text-uppercase"
                            />
                        </div>
                        {filterDate?.from === "" ? "" :
                            <button className="py-0 px-1 d-flex align-items-center cancelX" onClick={() => { setFilterDate({ from: "", to: "" }) }}>
                                <i className="fa-solid fa-circle-xmark text-theme"></i>
                            </button>}
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-end">
                        <i onClick={exportToExcel} className="fa-solid fa-download ms-4 cursor-pointer fs-5"></i>
                    </div>
                </div>
                <div className="mt-4">
                    <div className="overflow">
                        <table className="table">
                            <thead>
                                <tr className="text-center">
                                    <th className="text-center">S. No</th>
                                    <th>Name</th>
                                    <th>Booked </th>
                                    <th>Ongoing </th>
                                    <th>Pending </th>
                                    <th>Cancelled </th>
                                    <th> Pickup </th>
                                    <th> Total </th>
                                    <th> Credit </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    filterData && filterData?.length > 0 ?
                                        filterData?.map((element, i) => {
                                            if (element?.staffId) {
                                                return (
                                                    <tr key={i} id={i} className="align-middle text-center">
                                                        <td className="text-center">{(i + 1)}</td>
                                                        <td> <Link className="text-capitalize" to={`/subadmin/report/${element?.staffId}`}>{element?.name}</Link>  </td>
                                                        <td>{element?.Booked || 0}</td>
                                                        <td>{element?.Ongoing || 0}</td>
                                                        <td>{element?.Pending || 0}</td>
                                                        <td>{element?.Cancelled || 0}</td>
                                                        <td>{element?.Completed || 0}</td>
                                                        <td>{element?.total || 0}</td>
                                                        <td style={{ backgroundColor: "#00800057" }}>{element?.Credit || 0}</td>
                                                    </tr>
                                                )
                                            }
                                        }
                                        ) : <tr><td colSpan={12} className="text-center">{"No Data Found"}</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

            </Modal>
            <Modal header="Download Sales Report" centered={true} onShow={salesModal} toggle={salesToggle} overlayToggle={salesToggle}>
                <div className="text-center">
                    <div className="mb-3 text-start">
                        <label htmlFor="salesFrom" className="form-label">From</label>
                        <div className="filter-date datepicker-top">
                            <DatePicker portal zIndex={2000} disabled={salesLoading} value={salesData?.from ? new Date(salesData?.from) : ""} format="DD/MM/YYYY" onChange={(e) => setSalesData((prev) => ({ ...prev, from: new Date(e), to: "" }))} />
                        </div>
                    </div>
                    <div className="mb-3 text-start">
                        <label htmlFor="salesTo" className="form-label">To</label>
                        <div className="filter-date datepicker-top">
                            <DatePicker minDate={salesData?.from ? new Date(salesData?.from) : undefined} portal zIndex={2000} disabled={salesLoading || !salesData?.from} value={salesData?.to ? new Date(salesData?.to) : ""} format="DD/MM/YYYY" onChange={(e) => setSalesData((prev) => ({ ...prev, to: new Date(e) }))} />
                        </div>
                    </div>
                    <div className="mb-3 text-start">
                        <label htmlFor="salesPerson" className="form-label">Person</label>
                        <select
                            className="form-select"
                            id="salesPerson"
                            disabled={salesLoading}
                            value={salesData?.person || "all"}
                            onChange={(e) => setSalesData((prev) => ({ ...prev, person: e.target.value }))}
                        >
                            <option value="all">All</option>
                            {
                                lead?.length ? lead?.map((element, i) => (
                                    <option key={i} value={element?.leadId}>{element?.name}</option>
                                )) : ""
                            }
                        </select>
                    </div>
                    <button className="btn btn-success" onClick={exportSalesReport} disabled={salesLoading}>{salesLoading ? "Downloading..." : "Submit"}</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default List;